import { adminSchema } from '@/lib/supabase/client'

export interface AuditLogEntry {
  id: string
  admin_id: string
  action: string
  target_type: string
  target_id: string | null
  details: Record<string, unknown>
  ip_address: string | null
  created_at: string
}

export interface AuditLogParams {
  limit?: number
  offset?: number
  action?: string
  targetType?: string
}

export async function fetchAuditLog(params: AuditLogParams = {}): Promise<{ entries: AuditLogEntry[]; total: number }> {
  const limit = params.limit ?? 50
  const offset = params.offset ?? 0

  let query = adminSchema()
    .from('audit_log')
    .select('*', { count: 'exact' })
    .order('created_at', { ascending: false })
    .range(offset, offset + limit - 1)

  if (params.action) query = query.eq('action', params.action)
  if (params.targetType) query = query.eq('target_type', params.targetType)

  const { data, error, count } = await query
  if (error) throw error
  return { entries: (data ?? []) as AuditLogEntry[], total: count ?? 0 }
}
